module.exports = __webpack_public_path__ + "static/media/cityguide-logo@2x.3fe0ed70.png";